import Main from './main';
import Print from './print';

const routes = [
  {
    path: '/*',
    Component: Main,
    props: {
      exact: true,
    },
  },
  {
    path: '/print',
    Component: Print,
    props: {
      exact: true,
    },
  },
];

export default routes;
